/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */


export const FETCH_BOOK_DETAILS_SUCCESS = 'FETCH_BOOK_DETAILS_SUCCESS';

export function fetchBookDetailsSuccess(payload){
    return {type: FETCH_BOOK_DETAILS_SUCCESS, payload: payload};
}

export const CLEAR_BOOKDETAILS = 'CLEAR_BOOKDETAILS';

export function clearBookDetails(payload) {
    return {type: CLEAR_BOOKDETAILS};
}

export const GET_FRONT_COVER_PAGE_DETAILS_SUCCESS = 'GET_FRONT_COVER_PAGE_DETAILS_SUCCESS';

export function getFrontCoverPageDetailsSuccess(frontCoverPageDetails) {
    return {type: GET_FRONT_COVER_PAGE_DETAILS_SUCCESS, payload: frontCoverPageDetails};
}

export const GET_COVER_PAGE_THUMBNAILS_SUCCESS = 'GET_COVER_PAGE_THUMBNAILS_SUCCESS';

export function getCoverPageThumbnailsSuccess(coverPageThumbnails) {
    return {type: GET_COVER_PAGE_THUMBNAILS_SUCCESS, coverPageThumbnails: coverPageThumbnails};
}

export const CHANGE_TOC_NUMERATION = 'CHANGE_TOC_NUMERATION';

export function changeTocNumeration(tocNumeration) {
    return {type: CHANGE_TOC_NUMERATION, printTOCChapterType: tocNumeration};
}

export const CHANGE_FORCED_TRIMSIZE = 'CHANGE_FORCED_TRIMSIZE';

export function changeForcedTrimSize(forcedTrimSize) {
    return {type: CHANGE_FORCED_TRIMSIZE, forcedTrimSize: forcedTrimSize};
}

export const CHANGE_CHAPTER_HEADERS = 'CHANGE_CHAPTER_HEADERS';

export function changeChapterHeaders(chapterHeaders) {
    return {type: CHANGE_CHAPTER_HEADERS, chapterHeaders: chapterHeaders};
}

export const CHANGE_HAS_REQUESTED_ACCESSCODE = 'CHANGE_HAS_REQUESTED_ACCESSCODE';

export function changeAccessCodeRequested(accessCodeRequested) {
    return {type: CHANGE_HAS_REQUESTED_ACCESSCODE, accessCodeRequested: accessCodeRequested};
}

export const CHANGE_TRIMSIZE = 'CHANGE_TRIMSIZE';

export function changeTrimSize(trimSize) {
    return {type: CHANGE_TRIMSIZE, trimSize: trimSize};
}

export const GET_FRONT_COVER_THUMBNAIL_URL = 'GET_FRONT_COVER_THUMBNAIL_URL';

export function getFrontCoverThumbnailURLSuccess(payload) {
    return {type: GET_FRONT_COVER_THUMBNAIL_URL, payload: payload};
}


// WEBPACK FOOTER //
// ./src/_actions/bookdetails.actions.js